export function isDefined<T>(input: null | undefined | T): input is T {
  return input !== null && typeof input !== 'undefined'
}

export const isUndefined = <T>(item: T): boolean => !isDefined(item)

export function convertToNumber(item: string | undefined): number | undefined {
  if (!isDefined(item)) return undefined

  const parsed = Number(item)
  return isNaN(parsed) ? undefined : parsed
}

export function isObject(item: any): item is object {
  return typeof item === 'object'
}

export function insertIf(condition: boolean, ...elements: any[]) {
  return condition ? elements : []
}
